export let ApiErrorType = /*#__PURE__*/function (ApiErrorType) {
  ApiErrorType["client"] = "client";
  ApiErrorType["clientWithDetails"] = "clientWithDetails";
  ApiErrorType["json"] = "json";
  ApiErrorType["jwt"] = "jwt";
  ApiErrorType["unknown"] = "unknown";
  ApiErrorType["timeout"] = "timeout";
  return ApiErrorType;
}({});